import { UnitStateV2 } from '@eppendorf/vnls-device-service-utils';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { useDeviceSnapshot } from '$features/monitoring/device-snapshot.api';
import { MonitoringParameterCentrifugeLarge } from '$features/monitoring/parameters/monitoring-parameter-centrifuge-large';
import { MonitoringParameterSimple } from '$features/monitoring/parameters/monitoring-parameter-simple';
import styles from '$features/monitoring/parameters/monitoring-parameter.module.scss';
import { MonitoringParameterWrapperSnapshot } from '$features/monitoring/parameters/snapshot/monitoring-parameter-wrapper-snapshot';
import { useDeviceTelemetryDataForSnapshot } from '$features/monitoring/parameters/useDeviceTelemetryDataForSnapshot';

export function MonitoringParameters() {
  const [searchParams] = useSearchParams();

  const { data: snapshot } = useDeviceSnapshot({
    manufacturer: searchParams.get('manufacturer')!,
    serialNumber: searchParams.get('serialNumber')!,
  });

  const { t } = useTranslation();
  const { primaryParameters, secondaryParameters } =
    useDeviceTelemetryDataForSnapshot(snapshot);

  const isOnline =
    snapshot?.currentShadow?.activityState &&
    snapshot?.currentShadow?.activityState !== UnitStateV2.Offline.toString();

  return (
    <div className="monitoring-parameters">
      {primaryParameters.map((telemetry) => (
        <MonitoringParameterWrapperSnapshot
          key={telemetry.telemetryId}
          telemetry={telemetry}
          snapshot={snapshot!}
        />
      ))}

      {Boolean(secondaryParameters.length) && (
        <div className={cn('box', styles.monitoringParameterBox)}>
          <div role="button" tabIndex={0}>
            <div className={styles.monitoringParameterSimpleGrid}>
              {secondaryParameters.map((tele) => (
                <MonitoringParameterSimple
                  key={tele.telemetryId}
                  name={tele.name ?? tele.telemetryId}
                  value={
                    isOnline ? (tele.valueString ?? '') : t('monitoringDetail.noLiveData')
                  }
                  timestamp={isOnline ? new Date(tele.receivedAt).valueOf() : 0}
                  className={styles.monitoringParameterSimpleCell}
                  fullWidth={secondaryParameters.length === 1}
                />
              ))}
            </div>
          </div>
        </div>
      )}

      <MonitoringParameterCentrifugeLarge snapshot={snapshot} />
    </div>
  );
}
